import React from 'react';
import styled from 'styled-components';
import ArrowDown from '../../asset/icon/below.png';
import ArrowLeft from '../../asset/icon/left.png';
import ArrowUp from '../../asset/icon/up.png';
import ArrowRight from '../../asset/icon/now.png';
import { useGuideModeStore } from '../../shared/store/authStore';
import { imHereSmall } from '../../shared/component/Animation';
import { paperTextureSmall } from '../../shared/component/paperTexture';


export interface NoticeCardProps {
  arrowDirection: 'up' | 'down' | 'left' | 'right' | 'none';
  position: {
    top: string;
    left: string;
    right: string;
    bottom: string;
  }
  noticeIndex: string;
  noticeTotal: string;
  content: string;
  content2?: string;
  restriction?: string;
  onClick?: () => void;
}

const NoticeCard: React.FC<NoticeCardProps> = ({ noticeIndex, noticeTotal, content, content2, restriction, arrowDirection, position, onClick }) => {
  const { isGuideMode } = useGuideModeStore();

  if (!isGuideMode) return null;

  return (
    <NoticeCardComp $position={position} $arrowDirection={arrowDirection} onClick={onClick}>
      {arrowDirection === 'left' && <ArrowWrapper><ArrowIcon $backgroundImg={ArrowLeft} /></ArrowWrapper>}
      {arrowDirection === 'up' && <ArrowWrapper><ArrowIcon $backgroundImg={ArrowUp} /></ArrowWrapper>}
      <ContentWrapper>
        {noticeIndex === 'NOTICE' ?
          <span>
            <Notice>Notice:</Notice>{content}
          </span> :
          noticeIndex === 'SKIP' ?
            <span>{content}</span> :
            <div>
              <StepIndicator>
                <Step>{noticeIndex}/{noticeTotal}</Step>
                {noticeIndex === noticeTotal ?
                  <span>
                    Click to End
                  </span> :
                  <span>
                    Click to Continue =&gt;
                  </span>
                }
              </StepIndicator>
              <div>{content}</div>
              {content2 && <div>{content2}</div>}
              {restriction && <Restriction>{restriction}</Restriction>}
            </div>
        }
      </ContentWrapper>
      {arrowDirection === 'down' && <ArrowWrapper><ArrowIcon $backgroundImg={ArrowDown} /></ArrowWrapper>}
      {arrowDirection === 'right' && <ArrowWrapper><ArrowIcon $backgroundImg={ArrowRight} /></ArrowWrapper>}
    </NoticeCardComp >
  );
};

const NoticeCardComp = styled.div<{ $position: { top: string; left: string; right: string; bottom: string }; $arrowDirection: string }>`
  position: fixed;
  top: ${({ $position }) => $position.top === '0' ? 'auto' : $position.top};
  left: ${({ $position }) => $position.left === '0' ? 'auto' : $position.left};
  right: ${({ $position }) => $position.right === '0' ? 'auto' : $position.right};
  bottom: ${({ $position }) => $position.bottom === '0' ? 'auto' : $position.bottom};
  width: fit-content;

  display: flex;
  flex-direction: row;
  gap: 4px;

  padding: 10px 8px;
  z-index: 2;

  ${paperTextureSmall}
  ${({ theme }) => theme.typography.Body_03_2};
  ${({ $arrowDirection }) => $arrowDirection !== 'none' ? imHereSmall : ''}
  cursor: pointer;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 6px;
  gap: 3px;
`;

const Step = styled.div`
`;

const StepIndicator = styled.div`
  position: absolute;
  top: -20px;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-top: 4px;
  ${({ theme }) => theme.typography.Body_04};
  color: ${({ theme }) => theme.colors.color_Gray_04};
`;

const Notice = styled.h4`
  display: inline;
  padding-right: 5px;
`;

const Restriction = styled.span`
  ${({ theme }) => theme.typography.Body_04};
`;

const ArrowWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ArrowIcon = styled.div<{ $backgroundImg: string }>`
  width: clamp(8px, 2vw, 12px);
  height: clamp(8px, 2vw, 12px);
  background-image: url(${({ $backgroundImg }) => $backgroundImg});
  background-size: cover;
  background-position: center;
`;

export default NoticeCard;
